<template>
  <va-card class="mb-4">
    <va-card-title>
      {{ $t(`${entityType}.directNavigation.title`) }}
    </va-card-title>
    <va-card-content>
      <div class="input-group">
        <va-input
          v-model="entityId"
          :placeholder="$t(`${entityType}.directNavigation.placeholder`)"
          :label="$t(`${entityType}.directNavigation.label`)"
          class="direct-nav-input"
        />
        <va-button
          @click="navigateToEntity"
          :disabled="!entityId || entityId.trim() === ''"
          color="primary"
          size="small"
          class="direct-nav-button"
        >
          Go
        </va-button>
      </div>
    </va-card-content>
  </va-card>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  entityType: {
    type: String,
    required: true,
    validator: value =>
      [
        "users",
        "organizations",
        "invites",
        "templates",
        "products",
        "entitlements"
      ].includes(value)
  },
  basePath: {
    type: String,
    required: true
  }
});

const router = useRouter();
const entityId = ref("");

// Route mapping for different entity types
const routeMapping = {
  users: "user",
  organizations: "organization",
  invites: "invite",
  templates: "template",
  products: "product",
  entitlements: "entitlement"
};

function navigateToEntity() {
  if (!entityId.value || entityId.value.trim() === "") {
    return;
  }

  const trimmedId = entityId.value.trim();
  const routeName = routeMapping[props.entityType];
  const fullPath = `${props.basePath}/${trimmedId}`;

  router.push({ path: fullPath });
}
</script>

<style scoped>
.input-group {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  width: 100%;
}

.direct-nav-input {
  flex: 1;
}

.direct-nav-button {
  height: 36px;
  min-width: auto;
  padding: 0 16px;
  flex-shrink: 0;
  margin-bottom: 2px;
}

@media (max-width: 768px) {
  .input-group {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .direct-nav-button {
    height: 40px;
    margin-bottom: 0;
  }
}
</style>
